
import { defineComponent } from 'vue'
import linkTabDescriptor from '@/modules/managers/datasetManagement/detailView/metadataCard/DatasetManagementMetadataCardDescriptor.json'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import Card from 'primevue/card'

export default defineComponent({
    components: { Card, Column, DataTable, Dropdown, Checkbox },
    props: { propMetadata: { type: Array as any } },
    emits: ['touched'],
    data() {
        return {
            linkTabDescriptor,
            fieldMetadataTypes: linkTabDescriptor.fieldsMetadataTypes,
            valueTypes: linkTabDescriptor.valueTypes,
            fieldsMetadata: [] as any
        }
    },
    created() {
        this.fieldsMetadata = this.propMetadata
    },
    watch: {
        propMetadata: {
            handler() {
                this.fieldsMetadata = this.propMetadata
            },
            deep: true
        }
    },

    methods: {
        warnForDuplicateSpatialFields() {
            var numberOfSpatialAttribute = 0
            for (let i = 0; i < this.fieldsMetadata.length; i++) {
                if (this.fieldsMetadata[i].fieldType == 'SPATIAL_ATTRIBUTE') {
                    numberOfSpatialAttribute++
                    if (numberOfSpatialAttribute > 1) {
                        this.$store.commit('setError', { title: this.$t('common.error.saving'), msg: this.$t('managers.datasetManagement.duplicateSpatialAttribute') })
                        return
                    }
                }
            }
        }
    }
})
